import { render, staticRenderFns } from "./customizationIndicatorsSection.vue?vue&type=template&id=0f3d398e&scoped=true"
import script from "./customizationIndicatorsSection.vue?vue&type=script&lang=js"
export * from "./customizationIndicatorsSection.vue?vue&type=script&lang=js"
import style0 from "./customizationIndicatorsSection.vue?vue&type=style&index=0&id=0f3d398e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d398e",
  null
  
)

export default component.exports